// extracted by mini-css-extract-plugin
module.exports = {"pageDescription":"page-description_pageDescription__jGr8z"};